import React from 'react'
import Main from "./Main";
import reducer from "../../store"
import withReducer from 'app/store/withReducer';

function ReOrder() {
    return <Main/>
};

export default withReducer('modulesApp', reducer) (ReOrder)